module.exports = __webpack_public_path__ + "img/portadac2.d563ea58.jpg";